import { useMemo } from "react";
import { CircularProgress, Button as MuiButton } from "@mui/material";
import { getButtonColors } from "./util";

export default function Button({
    loading,
    disabled,
    color = "primary",
    startIcon,
    variant = "soft",
    sx,
    textColor,
    bgColor,
    ...props
}) {
    const { bg, text, border, shadow } = useMemo(() => {
        return getButtonColors(color, variant, {
            text: textColor,
            bg: bgColor,
        });
    }, [color, variant, textColor, bgColor]);

    return (
        <MuiButton
            {...props}
            disabled={loading || disabled}
            startIcon={
                loading ? (
                    <CircularProgress size={20} sx={{ color: text }} />
                ) : (
                    startIcon
                )
            }
            sx={{
                backgroundColor: bg,
                color: text,
                border: `1px solid ${border}`,
                padding: "14px",
                borderRadius: "12px",
                textTransform: "none",
                height: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "16px",
                transition: "all 0.2s",
                fontWeight: "400",

                "&:hover": {
                    backgroundColor: variant === "text" ? shadow : bg,
                    boxShadow: `0 1px 8px ${shadow}`,
                    transform: "translateY(-2px)",
                },

                "&:active": {
                    transform: "translateY(2px)",
                },

                ...sx,
            }}
        />
    );
}
